import React, {Fragment} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";

const CalendarSubmenu = ( props ) =>
{
    return (
        <Fragment>
        <AppSidebarGroup title='Filters' default='all'>
            <AppSidebarMenuItem title='All Items' iconName='icon-star' name='all'/>
            <AppSidebarMenuItem title='Birthdays' iconName='icon-star' name='birthdays'/>
            <AppSidebarMenuItem title='Settling In' iconName='icon-tag' tagColor='text-purple' name='settling'/>
        </AppSidebarGroup>

        </Fragment>
    )
}

export default CalendarSubmenu ;